var eventTypes = ultra_settings.event_types;

var getEventJSON = _.memoize(function() {
    return $.getJSON( ultra_settings.endpoints.events_url );
});

var getEventsByType = _.memoize(function() {
    return getEventJSON()
        .then(function (events) {
            var eventTypeMap = [];

            $.each(eventTypes, function (eventTypeKey, eventType) {
                eventTypeMap[eventType.type] = eventTypeKey;
                eventType.events = [];
            });

            $.each(events, function (eventKey, event) {
                eventTypes[eventTypeMap[event.type]].events.push(event);
            });

            return eventTypes;
        });
});

var getEventsByTypeGalleries = _.memoize(function() {
    return getEventsByType()
        .then(function (eventTypeData) {
            var eventTypeMap = [];

            $.each(eventTypeData, function (eventTypeKey, eventType) {
                eventTypeMap[eventType.type] = eventTypeKey;
            });

            return $.get(ultra_settings.endpoints.gallery_url, function() {})
                .then(function(data) {
                    var galleries = data.data;

                    $.each(galleries, function(galleryKey, gallery){
                        var events = eventTypeData[eventTypeMap[gallery.type]].events;
                        var event = _.find(events, {'code': gallery.code});
                        if (event) {
                            if (!event.galleries) {
                                event.galleries = [];
                            }
                            event.galleries.push(gallery);
                        }
                    });
                    return eventTypeData;
                });
        });
});
